export default __webpack_public_path__ + "static/media/PANDA.3cdb3888.jpg";